import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Input/InputFile.css'
import { Fade } from 'react-awesome-reveal'

{/*
<InputFile
    theme={'light' | 'dark'}
    ref={}
    file={} setFile={}
    fileError={} setFileError={}
    icon={<FontAwesomeIcon icon={faFile} />}
    placeholder={""}
/>
--inputTextLight: #ffffff;
--inputTextLightText: #49574b;
--inputTextDark: #eef5ef;
--inputTextDarkText: #49574b;
--inputTextSuccess: #435e48;
--inputTextError: #BB4040;
--inputFileText: #3f3f3f;
*/}

const InputFile = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({ fileValidation: (file) => fileValidation(file) }))

    const inputFileRef = useRef(null)
    const [filename, setFilename] = useState()

    function fileValidation(files) {

        const fileList = files instanceof FileList ? files : files ? [files] : []
        if (fileList && fileList.length > 0) {
            var filename = []
            for (var i = 0; i < fileList.length; i++) {
                filename.push(fileList[i].name)
            }
            setFilename(filename)
            if (props.format && props.format[0] !== "all") {
                for (let i2 = 0; i2 < fileList.length; i2++) {
                    if (props.format.find((item2) => item2 === /(?:\.([^.]+))?$/.exec(fileList[i2].name)[1]) === undefined) {
                        props.setFileError(true)
                        return true
                    }
                }
            }
            props.setFileError(false)
            return true
        } else {
            props.setFileError(true)
            return false
        }

    }

    return (

        <>
            <div className='inputFileText'>
                {props.placeholder}
            </div>
            <InputGroup>
                <InputGroup.Text className={['inputFileIcon', props.theme === 'light' ? 'inputFileIconLight' : 'inputFileIconDark', props.fileError === false ? 'inputFileIconSuccess' : props.fileError ? 'inputFileIconError' : null].join(" ")}>
                    {props.icon ? props.icon : <FontAwesomeIcon icon={faFilePdf} />}
                </InputGroup.Text>
                <Form.Control
                    ref={inputFileRef}
                    type='file'
                    multiple={props.multiple}
                    className={['inputFile', props.theme === 'light' ? 'inputFileLight' : 'inputFileDark', props.fileError === false ? 'inputFileSuccess' : props.fileError ? 'inputFileError' : null].join(" ")}
                    onChange={(e) => { props.setFile(e.target.files[0]); fileValidation(e.target.files) }}
                />
            </InputGroup>
            {filename && props.multiple ?
                filename.map((itemName) => {
                    return (
                        <Fade key={itemName} top>
                            {props.format[0] === 'all' || props.format.find((itemFormat) => itemFormat === /(?:\.([^.]+))?$/.exec(itemName)[1]) ?
                                <div className={'inputFilePreviewSuccess'}>
                                    <li>{itemName} ({props.textExtSuccess})</li>
                                </div>
                                :
                                <div className={'inputFilePreviewError'}>
                                    <li>{itemName} ({props.textExtError})</li>
                                </div>
                            }
                        </Fade>
                    )
                })
                : null
            }
        </>

    )

})

export default InputFile